import h, { FunctionComponent } from 'preact';

const Messages: FunctionComponent<MessagesProps> = ({
    success,
    error,
    warning,
    isSpecialKnitwear
}) => {
    if (!success && !error && !warning && !isSpecialKnitwear) {
        return null;
    }

    return (
        <>
            {isSpecialKnitwear ? (
                <div class="text-md line-height-md mb-2">
                    <p>
                        There are{' '}
                        <a
                            href="https://oneandall.co.uk/minimum-order-quantities"
                            target="_blank"
                            class="text-underline font-weight-bold"
                        >
                            minimum order quantities
                        </a>{' '}
                        and possibly small order supplements which apply to this product.
                    </p>
                </div>
            ) : null}
            <div id="js-alerts-wrapper" class="basket__alerts" aria-live="polite">
                {success ? <div class="alert alert-success t__flash-success">{success}</div> : null}
                {error ? <div class="alert alert-danger t__flash-error">{error}</div> : null}
                {warning ? <div class="alert alert-warning t__flash-error">{warning}</div> : null}
            </div>
        </>
    );
};

interface MessagesProps {
    success: string;
    error: string;
    warning: string;
    isSpecialKnitwear: boolean;
}

export default Messages;
